import { COLORS } from '../../../../../config/designSystem/Colors';
import { CircleButton } from '../../CirculButton';
import { FC } from 'react';
import { ParagraphMBold, ParagraphSRegular } from '../../../../../config/designSystem/typography';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { observer } from 'mobx-react';
import { useIsSmallWeb } from '../../../../../hooks/ui/useIsSmallWeb';

interface SingleSelectProps {
  label: string;
  /**
   * Optional secondary line displayed under the label — used by chooseService
   * to surface the WPO `shortDescription` so users understand what each
   * service is. Omitted: renders single-line as before.
   */
  caption?: string;
  onPress: () => void;
  selected: boolean;
}

const _SingleSelectChoice: FC<SingleSelectProps> = ({
  label,
  caption,
  onPress,
  selected
}) => {

  const colorAnswer = selected
    ? COLORS.content.accent
    : COLORS.content.primary;

  const EDGE_WIDTH = 20;
  const {isLargeEnoughForLateralBarWeb} = useIsSmallWeb();

  return (
    <TouchableOpacity
      onPress={onPress}
      style={[
        styles.button,
        selected && styles.selected,
        !selected && styles.notSelected,
        !isLargeEnoughForLateralBarWeb && {width: '90%'},
        isLargeEnoughForLateralBarWeb && {width: 500}
      ]}
    >
      <View style={styles.textColumn}>
        <ParagraphMBold
          selectable={false}
          color={colorAnswer}
          align={true}
        >
          {label}
        </ParagraphMBold>
        {caption ? (
          <ParagraphSRegular
            selectable={false}
            color={COLORS.content.secondary}
            align={true}
          >
            {caption}
          </ParagraphSRegular>
        ) : null}
      </View>
      <View style={{alignSelf: 'center', width: EDGE_WIDTH, position:'absolute', right: 0, marginRight: 12}}>
        <CircleButton selected={selected} edge={EDGE_WIDTH} />
      </View>
    </TouchableOpacity>

  );
};

const styles = StyleSheet.create({
  button: {
    borderRadius: 12,
    padding: 16,
    flexDirection: 'row',
    columnGap: 12,
    backgroundColor: COLORS.surface.contrast,
    marginVertical: 8,
    alignSelf:'center',
    // Leave room for the radio button on the right so the caption (when
    // present) doesn't collide with it.
    paddingRight: 44,
  },
  textColumn: {
    flex: 1,
    rowGap: 4,
  },
  selected: {
    borderColor: COLORS.border.accent,
    borderWidth: 2,
    shadowColor: '#E9E8FA',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.8,
    shadowRadius: 8,
    elevation: 8,
  },
  notSelected: {
    shadowColor: 'rgba(103, 91, 223, 1)',
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 4,
  }
});


export const SingleSelectChoice = observer(_SingleSelectChoice);
